<script setup lang="ts">
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from './stores/auth'
import NavBar from './components/NavBar.vue'

const router = useRouter()
const authStore = useAuthStore()

onMounted(async () => {
  // Check for OAuth callback token in URL
  const urlParams = new URLSearchParams(window.location.search)
  const token = urlParams.get('token')
  if (token) {
    // Store the session token and clean up URL
    localStorage.setItem('session_token', token)
    window.history.replaceState({}, '', window.location.pathname)
  }

  await authStore.checkAuth()
})
</script>

<template>
  <div class="min-h-screen flex flex-col">
    <NavBar v-if="authStore.isAuthenticated" />
    <main class="flex-1">
      <router-view />
    </main>
  </div>
</template>
